import React, { useState } from 'react';
import { Alert, Button, FormControlLabel, Grid, LinearProgress, Paper, Switch } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PageHeader from '../../../components/page-header';
import { useHomeController } from './context/home-controller';
import { useHomeState } from './context/home-context';
import { HomeSectionList } from './components/home-section-list';
import { HomeSectionDrawer } from './components/home-section-drawer';
import { HomeSectionItemDrawer } from './components/home-section-item-drawer';
import { SectionsHeader } from '../components/sections-header';
import { HomePreviewDialog } from './components/home-preview-dialog';

export function HomeComponent() {
    const ctrl = useHomeController();
    const state = useHomeState();
    const { home } = state;
    const readOnly = !!home?.isDefault;
    const [previewOpen, setPreviewOpen] = useState(false);

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Customizar Home"
                    subtitle="Escolha as seções da página inicial, a ordem e o conteúdo de cada uma"
                    breadcrumbs={[{ label: 'Customizar Home' }]}
                    actions={home && (
                        <FormControlLabel
                            control={<Switch checked={home.isEnabled} onChange={ctrl.handleToggleStatus} disabled={ctrl.isSaving} />}
                            label={home.isEnabled ? 'Home customizada ativa' : 'Home customizada inativa'}
                        />
                    )}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 3 }}>
                    <SectionsHeader
                        count={state.sections.length}
                        hint="arraste para alterar a ordem de exibição"
                        action={(
                            <React.Fragment>
                                <Button variant="outlined" startIcon={<VisibilityIcon />} onClick={() => setPreviewOpen(true)} disabled={!home}>
                                    Pré-visualizar
                                </Button>
                                <Button variant="contained" startIcon={<AddIcon />} onClick={() => ctrl.openSectionDrawer()} disabled={!home}>
                                    Adicionar seção
                                </Button>
                            </React.Fragment>
                        )}
                    />

                    {state.loading && <LinearProgress sx={{ mb: 2 }} />}

                    {home && !home.isEnabled && (
                        <Alert severity="warning" sx={{ mb: 2 }}>
                            A home customizada está inativa: o portal exibe a home padrão. As alterações abaixo ficam salvas e passam a valer quando ela for ativada.
                        </Alert>
                    )}
                    {readOnly && (
                        <Alert severity="info" sx={{ mb: 2 }}>
                            A home ainda usa o layout padrão (Diário Oficial e Notícias, abaixo do carrossel de banners do topo). Ative a home customizada ou adicione uma seção para começar a personalizar.
                        </Alert>
                    )}

                    <HomeSectionList
                        sections={state.sections}
                        readOnly={readOnly}
                        onEditSection={ctrl.openSectionDrawer}
                        onDeleteSection={ctrl.handleDeleteSection}
                        onToggleSectionVisibility={ctrl.handleToggleSectionVisibility}
                        onReorderSections={ctrl.handleReorderSections}
                        onAddItem={(section) => ctrl.openItemDrawer(section)}
                        onEditItem={ctrl.openItemDrawer}
                        onDeleteItem={ctrl.handleDeleteItem}
                        onToggleItemVisibility={ctrl.handleToggleItemVisibility}
                        onReorderItems={ctrl.handleReorderItems}
                    />
                </Paper>
            </Grid>

            <HomeSectionDrawer
                open={state.sectionDrawer.open}
                section={state.sectionDrawer.section}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeSectionDrawer}
                onSave={ctrl.handleSaveSection}
            />
            <HomePreviewDialog
                open={previewOpen}
                sections={state.sections}
                isEnabled={!!home?.isEnabled}
                onClose={() => setPreviewOpen(false)}
            />
            <HomeSectionItemDrawer
                open={state.itemDrawer.open}
                section={state.itemDrawer.section}
                item={state.itemDrawer.item}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeItemDrawer}
                onSave={ctrl.handleSaveItem}
            />
        </React.Fragment>
    );
}
